
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.221 8.688c0 .14.026.325.078.554.052.224.107.401.164.531.11.26.427.537.954.829.49.265.973.398 1.453.398.14 0 .278-.008.414-.023.135-.021.286-.055.453-.102.161-.047.284-.083.367-.11a25.642 25.642 0 01.813-.304c.51-.182.966-.399 1.367-.649.661-.411 1.349-.973 2.062-1.687.714-.714 1.276-1.401 1.688-2.063.25-.4.466-.856.648-1.367.016-.047.063-.174.14-.383l.165-.43c.026-.083.062-.205.11-.366.046-.167.08-.318.1-.454.016-.135.024-.273.024-.414 0-.479-.133-.963-.398-1.453-.292-.526-.568-.843-.828-.953a3.119 3.119 0 00-.532-.164A2.631 2.631 0 008.91 0a.438.438 0 00-.164.023c-.094.032-.232.23-.414.594-.058.1-.136.24-.235.422l-.273.5c-.084.146-.164.284-.242.414-.016.021-.06.086-.133.195-.078.11-.136.204-.172.282a.485.485 0 00-.055.218c0 .105.076.235.227.391.146.156.307.3.484.43.172.13.333.268.484.414.146.146.22.265.22.36a.56.56 0 01-.04.179l-.062.156-.11.188a3.71 3.71 0 00-.093.148A8.2 8.2 0 016.97 6.75a8.2 8.2 0 01-1.836 1.36c-.01.005-.06.036-.148.093a20.05 20.05 0 01-.188.11 4.793 4.793 0 01-.156.062.56.56 0 01-.18.04c-.093 0-.213-.074-.359-.22a5.332 5.332 0 01-.414-.484 3.482 3.482 0 00-.43-.484C3.104 7.076 2.974 7 2.87 7a.485.485 0 00-.22.055 1.861 1.861 0 00-.28.172c-.11.072-.175.117-.196.132-.13.079-.268.16-.414.243a83.76 83.76 0 01-.5.273c-.182.099-.323.177-.422.234-.364.183-.562.32-.593.414a.438.438 0 00-.024.165z","fill":"#4F71E8"}})])
          )
        }
      }
    